import React from 'react';
import ContentCard from '../ContentCard';

const International = () => {
    return <div className='left-align'>
    <ContentCard title="International data transfers" content={
      <>
    <p>The transfer of personal data to third-party service providers outside of the EEA takes place on the basis of data protection adequacy decisions by the European Commission.</p>
    <p>The concerned processing is exclusively with Google and Microsoft.</p>

      </>
      }
      />


  </div>;
};

export default International;